
export const Spinner = ({ className = '' }: { className?: string }) => (
  <div className={`w-8 h-8 border-2 border-primary-blue border-t-transparent rounded-full animate-spin mx-auto ${className}`} />
); 